import { render } from "./PlanetDetail.vue?vue&type=template&id=20056c5e&scoped=true"
import script from "./PlanetDetail.vue?vue&type=script&lang=js"
export * from "./PlanetDetail.vue?vue&type=script&lang=js"

import "./PlanetDetail.vue?vue&type=style&index=0&id=20056c5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20056c5e"]])

export default __exports__